// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"fb5b590a","575":"2812de76","806":"4f095cbc","900":"cda81d03"}[chunkId] + ".chunk.css";
};